import type { ReactElement } from "react";
import ctl from "@netlify/classnames-template-literals";

import { SvgIcon } from "./SvgIcon";

const baseStyles = ctl(`
  mr-2
  animate-spin
  [animation-direction:reverse]
  flex-shrink-0
`);

export function LoadingGradientSpinnerIcon({
  color = "purple",
  size = 36,
}: {
  color?: "purple" | "white" | "teal";
  size?: number;
}): ReactElement {
  const loadingSpinnerStyles = baseStyles;

  let gradientStartColor: string;
  let gradientEndColor: string;
  let dotColor: string;

  switch (color) {
    case "white":
      gradientStartColor = "rgba(255, 255, 255, 1)";
      gradientEndColor = "rgba(255, 255, 255, 0.5)";
      dotColor = "#FFFFFF";
      break;
    case "teal":
      gradientStartColor = "rgba(50, 163, 170, 1)";
      gradientEndColor = "rgba(50, 163, 170, 0.5)";
      dotColor = "#32A3AA";
      break;
    case "purple":
    default:
      gradientStartColor = "rgba(199, 155, 250, 1)";
      gradientEndColor = "rgba(92, 66, 164, 1)";
      dotColor = "#A08FD0";
      break;
  }

  return (
    <SvgIcon
      className={loadingSpinnerStyles}
      viewBox="0 0 35 35"
      role="status"
      size={size}
    >
      <g clipPath="url(#paint0_angular_1045_2524_clip_path)">
        <g transform="matrix(0 0.01725 -0.01725 0 17.25 17.25)">
          <foreignObject
            x="-1036.63"
            y="-1036.63"
            width="2073.26"
            height="2073.26"
          >
            <div
              style={{
                background: `conic-gradient(from 90deg, ${gradientStartColor} 0deg, ${gradientEndColor} 63.243deg, rgba(255, 255, 255, 0) 360deg)`,
                height: "100%",
                width: "100%",
                opacity: 1,
                borderRadius: "50%",
              }}
            />
          </foreignObject>
        </g>
      </g>
      <path
        d="M34.5 17.25C34.5 26.7769 26.7769 34.5 17.25 34.5C7.72309 34.5 0 26.7769 0 17.25C0 7.72309 7.72309 0 17.25 0C26.7769 0 34.5 7.72309 34.5 17.25ZM5.15821 17.25C5.15821 23.9281 10.5719 29.3418 17.25 29.3418C23.9281 29.3418 29.3418 23.9281 29.3418 17.25C29.3418 10.5719 23.9281 5.15821 17.25 5.15821C10.5719 5.15821 5.15821 10.5719 5.15821 17.25Z"
        fill="transparent"
      />
      <circle cx="17.423" cy="31.912" r="2.5875" fill={dotColor} />
      <defs>
        <clipPath id="paint0_angular_1045_2524_clip_path">
          <path d="M34.5 17.25C34.5 26.7769 26.7769 34.5 17.25 34.5C7.72309 34.5 0 26.7769 0 17.25C0 7.72309 7.72309 0 17.25 0C26.7769 0 34.5 7.72309 34.5 17.25ZM5.15821 17.25C5.15821 23.9281 10.5719 29.3418 17.25 29.3418C23.9281 29.3418 29.3418 23.9281 29.3418 17.25C29.3418 10.5719 23.9281 5.15821 17.25 5.15821C10.5719 5.15821 5.15821 10.5719 5.15821 17.25Z" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
